export type Vec3 = { x: number; y: number; z: number };

export type WorldAxis = 'x' | 'y' | 'z';

export interface Measurement {
  id: string;
  label: string;
  a: Vec3;
  b: Vec3;
}

export interface MeasureSnapshot {
  measurements: ReadonlyArray<{
    id: string;
    label: string;
    distanceM: number;
    editing: boolean;
  }>;
  worldVisible: boolean;
  toolActive: boolean;
  placing: boolean;
}

export function fmtMeters(m: number): string {
  if (!Number.isFinite(m)) return '—';
  return `${m.toFixed(m >= 10 ? 1 : 2)} m`;
}

export function distance3(a: Vec3, b: Vec3): number {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  const dz = a.z - b.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

export function cloneVec3(v: Vec3): Vec3 {
  return { x: v.x, y: v.y, z: v.z };
}

export function nextMeasureLabel(count: number): string {
  if (count < 26) return String.fromCharCode(65 + count);
  return `M${count + 1}`;
}

export function reindexMeasureLabels(items: Measurement[]): void {
  items.forEach((m, i) => {
    m.label = nextMeasureLabel(i);
  });
}
